import React, { Component, useState } from 'react';
import { BrowserRouter , Route, Routes } from 'react-router-dom';
import Home from './components/pages/home';
import Register from './components/pages/Register';
import ForgetPassword from "./components/pages/ForgetPassword";
import SignInSide from './components/pages/SignInSide';
import './App.css';
import CheckInCheckOut from './components/pages/CheckInCheckOut';

import Mytest from './components/pages/Mytest';
import RoomFee from './components/menus/RoomFee';
import Reservation from './components/pages/Reservation';
import hotelvoucher from './components/reports/HotelVoucher'
import HotelVoucher from './components/reports/HotelVoucher';
import HotelInvoice from './components/reports/HotelInvoice';
import HotelVoucher_Print from './components/reports/HotelVoucher_Print';
import CredentialsSignInPage from './components/pages/CredentialsSignInPage';
import Booking from './components/pages/Booking';
function App(props) {
  const [user, setUser] = useState((localStorage.getItem("luxtrip-user")) ? JSON.parse(localStorage.getItem("luxtrip-user")): {});
  //console.log(window.innerWidth, window.innerHeight);
  console.log(props)
  
  return (

    <React.StrictMode>
    <BrowserRouter>

     <div className="App">
      
      <Routes >
  



   <Route     path="/"  element={<CredentialsSignInPage   />} /> 
            <Route     path="/Home"  element={<Home   />} />
             <Route path="/login"   element={<SignInSide />} />
                   <Route path="/register" element={<Register />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
           <Route     path="/checkin/:id"  element={<CheckInCheckOut />} />    
           <Route     path="/roomfee"  element={<RoomFee   />} />  
           <Route     path="/reservation"  element={<Reservation   />} />  
           <Route     path="/hotelvoucher"  element={<HotelVoucher  />} />  
           <Route     path="/hotelvoucher_Print"  element={<HotelVoucher_Print  />} />    
           <Route     path="/hotelinvoice"  element={<HotelInvoice  />} />  
           <Route path="/booking" element={<Booking />} />

            {/*  <Route path="/hesab_sanad" element={<Hesab_Sanad />} /> */}
     </Routes >      
     </div> 

    </BrowserRouter>
  </React.StrictMode> 
  );
}
export const apiMain = process.env.REACT_APP_API
export default App;
